import {
    ViewEncapsulation,
    Component,
    Input,
    ElementRef,
    OnInit,
    TemplateRef,
    input,
    output,
    Injector,
    inject,
    computed,
    ChangeDetectionStrategy,
    ViewChild,
    Renderer2,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { toObservable } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --bar-height: initial; --thumb-background: initial; --thumb-background-hover: var(--thumb-background); --thumb-background-active: var(--thumb-background); --thumb-background-disabled: var(--thumb-background); --thumb-width: initial; --thumb-height: initial; --thumb-border-radius: initial; --thumb-border-width: initial; --thumb-border-style: initial; --thumb-border-color: initial; --thumb-border-color-hover: var(--thumb-border-color); --thumb-border-color-active: var(--thumb-border-color); --thumb-border-color-disabled: var(--thumb-border-color); --thumb-box-shadow: initial; --track-background: initial; --track-background-hover: var(--track-background); --track-background-active: var(--track-background); --track-background-disabled: var(--track-background); --track-width: initial; --track-height: initial; --track-border-radius: initial; --track-border-width: initial; --track-border-style: initial; --track-border-color: initial; --track-border-color-hover: var(--track-border-color); --track-border-color-active: var(--track-border-color); --track-border-color-disabled: var(--track-border-color); --track-box-shadow: initial; --progress-background: initial; --progress-background-hover: var(--progress-background); --progress-background-active: var(--progress-background); --progress-background-disabled: var(--progress-background); --font-size: inherit; --font-weight: inherit; --line-height: initial; --color: inherit; position: relative; } :host .bazis-range__wrapper { --range: calc(var(--max) - var(--min)); --ratio: calc((var(--value) - var(--min)) / var(--range)); --sx: calc(0.5 * var(--thumb-width) + var(--ratio) * (100% - var(--thumb-width))); --ratio-from: calc((var(--value-from) - var(--min)) / var(--range)); --sx-from: calc(0.5 * var(--thumb-width) + var(--ratio-from) * (100% - var(--thumb-width))); --ratio-to: calc((var(--value-to) - var(--min)) / var(--range)); --sx-to: calc(0.5 * var(--thumb-width) + var(--ratio-to) * (100% - var(--thumb-width))); display: contents; } :host .bazis-range__pin { position: absolute; top: calc(0px - var(--thumb-width) - 2px); left: calc(var(--sx) - 0.5 * var(--thumb-width)); min-width: var(--thumb-width); font-size: var(--font-size); font-weight: var(--font-weight); line-height: var(--line-height); text-align: center; white-space: nowrap; pointer-events: none; color: var(--color); } :host .bazis-range__pin_from { left: calc(var(--sx-from) - 0.5 * var(--thumb-width)); } :host .bazis-range__pin_to { left: calc(var(--sx-to) - 0.5 * var(--thumb-width)); } :host .bazis-range__scale { display: flex; justify-content: space-between; } :host .bazis-range__scale__label { width: var(--thumb-width); text-align: center; } :host .bazis-range__thumbs { display: grid; position: relative; z-index: 1; } :host .bazis-range__track { position: absolute; top: 2px; width: 100%; height: var(--bar-height); border-radius: var(--track-border-radius); background-color: var(--track-background); } :host .bazis-range__progress { --range-progress-left: 0; position: absolute; top: 2px; left: 0; width: var(--sx); height: var(--bar-height); border-radius: var(--track-border-radius); background-color: var(--progress-background); } :host .bazis-range__progress.bazis-range__progress_interval { left: var(--sx-from); width: calc(var(--sx-to) - var(--sx-from)); } input[type=range].bazis-range__input { display: block; height: var(--bar-height); appearance: none; background: none; width: 100%; grid-area: 1/1; pointer-events: none; } input[type=range].bazis-range__input:focus { outline: none; } input[type=range].bazis-range__input::-webkit-slider-thumb { -webkit-appearance: none; width: var(--thumb-width); height: var(--thumb-height); border-radius: var(--thumb-border-radius); background: var(--thumb-background); border-width: var(--thumb-border-width); border-style: var(--thumb-border-style); border-color: var(--thumb-border-color); box-shadow: var(--thumb-box-shadow); margin-top: calc(var(--bar-height) * 0.5 - var(--thumb-height) * 0.5); pointer-events: auto; } input[type=range].bazis-range__input::-webkit-slider-runnable-track { height: var(--track-height); border-radius: var(--track-border-radius); border-width: var(--track-border-width); border-style: var(--track-border-style); border-color: var(--track-border-color); box-shadow: var(--track-box-shadow); } input[type=range].bazis-range__input::-webkit-slider-thumb:hover { background: var(--thumb-background-hover); } input[type=range].bazis-range__input::-webkit-slider-thumb:active { background: var(--thumb-background-active); } input[type=range].bazis-range__input::-webkit-slider-thumb:disabled { background: var(--thumb-background-disabled); } input[type=range].bazis-range__input::-moz-range-thumb { width: var(--thumb-width); height: var(--thumb-height); border-radius: var(--thumb-border-radius); background: var(--thumb-background); border-width: var(--thumb-border-width); border-style: var(--thumb-border-style); border-color: var(--thumb-border-color); box-shadow: var(--thumb-box-shadow); pointer-events: auto; } input[type=range].bazis-range__input::-moz-range-track { height: var(--track-height); border-radius: var(--track-border-radius); border-width: var(--track-border-width); border-style: var(--track-border-style); border-color: var(--track-border-color); box-shadow: var(--track-box-shadow); } input[type=range].bazis-range__input::-moz-range-thumb:hover { background: var(--thumb-background-hover); } input[type=range].bazis-range__input::-moz-range-thumb:active { background: var(--thumb-background-active); } input[type=range].bazis-range__input::-moz-range-thumb:disabled { background: var(--thumb-background-disabled); } input[type=range].bazis-range__input::-ms-fill-upper { background: transparent; border-color: transparent; } input[type=range].bazis-range__input::-ms-fill-lower { background: transparent; border-color: transparent; } input[type=range].bazis-range__input::-ms-thumb { width: var(--thumb-width); height: var(--thumb-height); border-radius: var(--thumb-border-radius); background: var(--thumb-background); border-width: var(--thumb-border-width); border-style: var(--thumb-border-style); border-color: var(--thumb-border-color); box-shadow: var(--thumb-box-shadow); margin-top: 0; box-sizing: border-box; pointer-events: auto; } input[type=range].bazis-range__input::-ms-track { height: var(--track-height); border-radius: var(--track-border-radius); border-width: var(--track-border-width); border-style: var(--track-border-style); border-color: var(--track-border-color); box-shadow: var(--track-box-shadow); box-sizing: border-box; } input[type=range].bazis-range__input::-ms-thumb:hover { background: var(--thumb-background-hover); } input[type=range].bazis-range__input::-ms-thumb:active { background: var(--thumb-background-active); } input[type=range].bazis-range__input::-ms-thumb:disabled { background: var(--thumb-background-disabled); }`,
);

@Component({
    selector: 'bazis-range',
    templateUrl: './range.component.html',
    // styleUrls: ['range.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false,
})
export class RangeElement implements OnInit {
    public el = inject(ElementRef);

    private injector = inject(Injector);

    readonly renderer = inject(Renderer2);

    // Minimum integer value of the range.
    readonly min = input<number>(0);

    // Maximum integer value of the range.
    readonly max = input<number>(100);

    readonly step = input<number>(1);

    readonly disabled = input<boolean>(false);

    readonly pin = input<boolean>(true);

    readonly pinDimension = input<string>(undefined);

    readonly value = input<number | string>();

    readonly values = input<{ from: number | string; to: number | string }>();

    readonly showScale = input(false);

    readonly dualThumbs = input(false);

    @Input() customPinTemplate: TemplateRef<any>;

    @ViewChild('range') fromEl: ElementRef;

    @ViewChild('rangeSecond') toEl: ElementRef;

    valueChanged = output<number | string>();

    valuesChanged = output<{ from: number | string; to: number | string }>();

    get scale() {
        const array = [];
        for (let i = this.min(); i <= this.max(); i = i + this.step()) {
            array.push(i);
        }
        return array;
    }

    styles = computed(() => {
        if (this.dualThumbs() && this.values()) {
            return {
                valueFrom: this.min()
                    ? Math.max(this.min(), +this.values().from)
                    : this.values().from,
                valueTo: this.max() ? Math.min(this.max(), +this.values().to) : this.values().to,
            };
        } else {
            return {
                value: this.value(),
            };
        }
    });

    fromControl = new FormControl();

    toControl = new FormControl();

    updFormValues$: Observable<any>;

    changeFrom$: Observable<any>;

    changeTo$: Observable<any>;

    ngOnInit(): void {
        // this.disabled = this.disabled !== undefined && this.disabled !== false;
        // this.checked = this.checked !== undefined && this.checked !== false;

        if (this.values() !== undefined) {
            this.updFormValues$ = toObservable(this.values, {
                injector: this.injector,
            }).pipe(
                tap((v) => {
                    console.log(v);
                    if (this.fromControl.value !== v.from) {
                        this.fromControl.setValue(+v.from);
                    }
                    if (this.toControl.value !== v.to) {
                        this.toControl.setValue(+v.to);
                    }
                }),
            );
        }
        if (this.value() !== undefined) {
            this.updFormValues$ = toObservable(this.value, {
                injector: this.injector,
            }).pipe(
                tap((v) => {
                    if (this.fromControl.value !== v) {
                        this.fromControl.setValue(+v);
                    }
                }),
            );
        }

        this.changeFrom$ = this.fromControl.valueChanges.pipe(
            tap((value) => {
                value = this.formatValue(value);

                if (this.dualThumbs() && this.values()) {
                    // const from = +value >= +this.toControl.value ? this.toControl.value : value;
                    // if (+from !== +value) {
                    //     this.fromControl.setValue(+from);
                    //     return;
                    // }

                    // this.valuesChanged.emit({
                    //     from,
                    //     to: this.toControl.value,
                    // });

                    if (this.fromEl && this.toEl) {
                        this.renderer.setStyle(this.fromEl.nativeElement, 'order', 1);
                        this.renderer.removeStyle(this.toEl.nativeElement, 'order');
                    }
                    this.valuesChanged.emit({
                        from: Math.min(this.toControl.value, value),
                        to: Math.max(this.toControl.value, value),
                    });
                } else {
                    this.valueChanged.emit(value);
                }
            }),
        );
        this.changeTo$ = this.toControl.valueChanges.pipe(
            tap((value) => {
                value = this.formatValue(value);
                // const to = +value <= +this.fromControl.value ? this.fromControl.value : value;
                // if (+to !== +value) {
                //     this.toControl.setValue(+to);
                //     return;
                // }
                // this.valuesChanged.emit({
                //     from: this.fromControl.value,
                //     to,
                // });

                if (this.fromEl && this.toEl) {
                    this.renderer.setStyle(this.toEl.nativeElement, 'order', 1);
                    this.renderer.removeStyle(this.fromEl.nativeElement, 'order');
                }
                this.valuesChanged.emit({
                    from: Math.min(value, this.fromControl.value),
                    to: Math.max(value, this.fromControl.value),
                });
            }),
        );

        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }

    private formatValue(value): number {
        if (this.max() && value > this.max()) {
            return this.max();
        }
        if (this.min() && value < this.min()) {
            return this.min();
        }
        return value;
    }
}
